import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { config } from "node-config-ts";
import { useQueryParameters } from "@hooks/use-query-parameters";
import { useInitializeApplication } from "@hooks/use-initialize-application";
import { useInitializeLanguage } from "@hooks/use-initialize-language";
import { useGoogleAnalytics } from "@hooks/use-google-analytics";
import { useScrollToTop } from "@hooks/use-scroll-to-top";
import { useInitializeCustomContent } from "@hooks/use-initialize-custom-content";
import { useUpdateSubmitButtonState } from "@hooks/use-update-submit-button-state";
import { getVerificationConfigurationState } from "@redux/selectors/verification-configuration-selectors";
import { Logger } from "@utils/logger";
import { navigateToUtilWithQueryParameters } from "@utils/navigation-util";
import { Spinner } from "../common/spinner/spinner";
import { ContentContainer } from "../content/content-container";

export const AxnContainer = () => {
    const { APPLICATION_ENVIRONMENT, REACT_APP_GA_KEY } = config;
    
    useEffect(() => {
        Logger.info('**** [App] Launching the AXNUI App ****');
    }, []);

    useQueryParameters();
    useInitializeApplication();
    useInitializeLanguage();
    useInitializeCustomContent();
    useUpdateSubmitButtonState();
    useGoogleAnalytics(APPLICATION_ENVIRONMENT, REACT_APP_GA_KEY);
    useScrollToTop();

    const location = useLocation();
    const navigate = useNavigate();
    const verificationConfigurationState = useSelector(getVerificationConfigurationState);

    if (!verificationConfigurationState.loadingFailed && (verificationConfigurationState.loading || verificationConfigurationState.config === null)) {
        Logger.info('[App] showing Loading spinner');
        return <Spinner />;
    }

    const pathName = location.pathname || window.location.pathname;
    let errorPath = "/error";
    if (pathName.includes("axnui")) {
        errorPath = "/axnui/error";
    }

    if (verificationConfigurationState.loadingFailed && pathName !== errorPath) {
        Logger.info("[App] return error redirect");
        navigateToUtilWithQueryParameters(errorPath, navigate, location.pathname, location.search);
    }

    return <ContentContainer/>;
};